const getBookingsRoute = () => {
    return {
        route: { name: 'BookingsGuestOperationsMainEventsList' },
        hasPermission: (permissions) => permissions.bookings.guestOperations.mainEventsList,
    };
};

const getEventsRoute = () => {
    return {
        route: { name: 'EventsGuestOperationsMainEventsList' },
        hasPermission: (permissions) => permissions.events.guestOperations.events.list,
    };
};

const getSeatingRoute = () => {
    return {
        route: { name: 'SeatingGuestOperationsMainEventList' },
        hasPermission: (permissions) => permissions.seating.guestOperations.mainEventList,
    };
};

export const getNavigationItems = ({ $t, user, router }) => {
    const bookingsRoute = getBookingsRoute({ user });
    const eventsRoute = getEventsRoute({ user });
    const seatingRoute = getSeatingRoute({ user });

    const route = router.currentRoute?.value;
    const isVenueMode = route?.path.includes('/venue-mode') ?? false;

    const desktopModeRoutes = [
        {
            label: $t('lang_navigation.EVENTS_LIST'),
            route: eventsRoute.route,
            iconName: 'tv',
            iconType: 'outlined',
            hasPermission: eventsRoute.hasPermission,
        },
        {
            label: $t('lang_bookings.PARTICIPANTS'),
            route: bookingsRoute.route,
            iconName: 'event',
            iconType: 'outlined',
            hasPermission: bookingsRoute.hasPermission,
        },
        {
            label: $t('lang_navigation.GUEST_LIST'),
            route: { name: 'GuestListMainEventsList' },
            iconName: 'group',
            iconType: 'outlined',
            hasPermission: (permissions) => permissions.guestList.mainEventsList,
        },
        {
            label: $t('lang_navigation.SEAT_DESIGNER'),
            route: seatingRoute.route,
            iconName: 'airline_seat_recline_normal',
            iconType: 'outlined',
            hasPermission: seatingRoute.hasPermission,
            submenu: {
                visible: false,
                items: [
                    {
                        label: $t('lang_navigation.ALLOCATE_SEATS'),
                        route: seatingRoute.route,
                        hasPermission: seatingRoute.hasPermission,
                    },
                    {
                        label: $t('lang_navigation.POSITION_DESIGNER'),
                        route: { name: 'SeatingFacilitiesList' },
                        hasPermission: (permissions) => permissions.seating.seatEditor,
                    },
                ],
            },
        },
        {
            label: $t('lang_navigation.REPORTS'),
            route: { name: 'ReportGenerator' },
            iconName: 'article',
            iconType: 'outlined',
            hasPermission: (permissions) => permissions.reports,
        },
        {
            label: $t('lang_navigation.SETTINGS'),
            route: { name: 'UsersList' },
            iconName: 'transfer_within_a_station',
            iconType: null,
            hasPermission: (permissions) => permissions.settings.userManagement.list,
            submenu: {
                visible: false,
                items: [
                    {
                        label: $t('lang_navigation.USER_MANAGEMENT'),
                        route: { name: 'UsersList' },
                        hasPermission: (permissions) => permissions.settings.userManagement.list,
                    },
                    {
                        label: $t('lang_navigation.ENTITIES'),
                        route: { name: 'EntitiesList' },
                        hasPermission: (permissions) => permissions.entities.list,
                    },
                    {
                        label: $t('lang_navigation.CLUBS'),
                        route: { name: 'ClubsList' },
                        hasPermission: (permissions) => permissions.clubs.list,
                    },
                    {
                        label: $t('lang_navigation.TRANSLATIONS'),
                        route: { name: 'Translations' },
                        hasPermission: (permissions) => permissions.settings.translations.list,
                    },
                    {
                        label: $t('lang_navigation.SEAT_TAGS'),
                        route: { name: 'SeatTagsMainEventsList' },
                        hasPermission: (permissions) => permissions.settings.seatTags,
                    },
                    {
                        label: $t('lang_navigation.PARTICIPANT_GROUPS'),
                        route: { name: 'ParticipantGroupsMainEventsList' },
                        hasPermission: (permissions) => permissions.settings.participantGroups,
                    },
                ],
            },
        },
    ];

    const venueModeRoutes = [];

    return isVenueMode ? venueModeRoutes : desktopModeRoutes;
};

export const filterNavigationByPermissions = (navigationItems, permissions, user) => {
    const hasPermission = (permissionCheckFn) => {
        return permissionCheckFn(permissions, user);
    };
    const checkPermission = (item) =>
        item.hasPermission ? hasPermission(item.hasPermission) : true;

    const getMenuItemPermissionPredicate = (isRootElement) => (item) => {
        const hasItemPermission = checkPermission(item);

        if (!isRootElement) {
            return hasItemPermission;
        }

        const hasAnySubItemPermission = item.submenu
            ? item.submenu.items.some((subItem) => checkPermission(subItem))
            : false;

        return hasItemPermission || hasAnySubItemPermission;
    };

    return navigationItems.filter(getMenuItemPermissionPredicate(true)).map((item) => ({
        ...item,
        submenu: item.submenu
            ? {
                  ...item.submenu,
                  items: item.submenu.items.filter(getMenuItemPermissionPredicate(false)),
              }
            : undefined,
    }));
};
